import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { isDefined } from "@omni/utils/helper.utils";
import { isEmpty } from "lodash-es";
import { useEffect, useState } from "react";

import { useBFFProductServiceApi } from "@/api/hooks/productService.hook";
import { ProductSliderComponent } from "@/components/Product/ProductSlider/productSlider.component";

import { useProductSliderContext } from "../productSlider.context";
import { ProductSliderSkeletonComponent } from "../skeleton/productSliderSkeleton.component";

export type SkuProductSliderProps = {
    skus: Array<string>;
};

const SkuProductSlider = ({ skus }: SkuProductSliderProps) => {
    const { prefetchedProducts } = useProductSliderContext();

    const [products, setProducts] = useState(prefetchedProducts);

    const [{ loading, error }, loadProducts] = useBFFProductServiceApi<
        any,
        any,
        Array<Product<ProductFieldSet.ProductTile>>
    >(
        {
            url: `/products`,
            method: "GET"
        },
        {
            manual: true,
            useCache: false,
            autoCancel: false
        }
    );

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (isEmpty(skus)) return;
        if (isDefined(products)) return;
        if (loading || error) return;

        loadProducts({
            params: {
                sku: skus.join(","),
                fields: ProductFieldSet.ProductTile
            }
        }).then(({ data }) => {
            setProducts(data);
        });
    }, [products, skus, loading, loadProducts, setProducts]);

    if (error) {
        return null;
    } else if (isDefined(products) && isEmpty(products)) {
        return null;
    } else if (isDefined(products) && !isEmpty(products)) {
        return <ProductSliderComponent products={products} />;
    } else {
        return <ProductSliderSkeletonComponent />;
    }
};

export { SkuProductSlider };
